import { Mesh } from 'three';
import type { WorldFeature } from '../types';
import { scaleColor } from '../../core/color';
import { createMeshBuilder } from '../mesh/meshBuilder';
import { materialsOf } from '../fabric/landmarks/landmarkMaterials';
import { marketPlan, marketStalls } from '../fabric/landmarks/marketStalls';
import { buildMarketGoods } from '../fabric/landmarks/marketGoods';
import { foundationHeight } from '../fabric/foundation';
import { createGroundElevation } from '../../site/groundElevation';
import { edgeIdFor } from '../mesh/attributes';

export const marketStockFeature: WorldFeature = {
  id: 'market-stock',
  label: 'Daytime market goods',
  weight: 0.2,
  build(ctx) {
    const colours = materialsOf(ctx.palette, ctx.rng.fork('stock-colours')),
      elevation = createGroundElevation(ctx.layout);
    const objects = ctx.layout.landmarks
      .filter((l) => l.id === 'landmark-vismarkt')
      .map((landmark) => {
        const { frame, rect } = marketPlan(landmark),
          builder = createMeshBuilder();
        const baseY =
          typeof landmark.params['baseY'] === 'number'
            ? landmark.params['baseY']
            : foundationHeight(landmark.footprint, elevation);
        buildMarketGoods(
          builder,
          { ...frame, origin: [frame.origin[0], baseY, frame.origin[2]] },
          marketStalls(landmark, (message) => {
            ctx.warn(message);
          }),
          { timber: colours.timber, board: scaleColor(colours.timber, 0.7), ground: colours.earth },
          { edgeId: edgeIdFor(1830), seed: 1538, strokeAngle: 0, extent: [rect.u1 - rect.u0, 4] }
        );
        const mesh = new Mesh(builder.build(), ctx.materials.painted());
        mesh.name = 'daytime-fish-market-stock';
        return mesh;
      });
    return {
      objects,
      obstacles: [],
      counts: { daytimeMarketStocks: objects.length },
      animated: [
        {
          id: 'market-opening-stock',
          update: () => undefined,
          setTimeOfDay(_minutes, activity) {
            for (const object of objects) object.visible = activity > 0.05;
          },
        },
      ],
    };
  },
};
